import { useState, useEffect } from 'react';
import { Container, Row, Col, Table } from 'react-bootstrap';
import '../App.css';

function TestResult({ result }) {
  const [score, setscore] = useState();

  //בודק כמה תשובות היו נכונות
  useEffect(() => {
    let score1 = 0
    result.forEach(question => {
      if (question.userAnswer) {
        question.correctAnswer === question.userAnswer ? score1 = score1 + 1 : score1 = score1
      }
    });
    setscore(score1)
  }, []);

  //טבלת השאלות והתשובות
  const tableResult = result.map(result => {
    if (result.userAnswer) {
      return (
        <tr key={result._id.$oid} className={result.correctAnswer === result.userAnswer ? 'success' : 'loss'}>
          <td><div>{result.question}</div>
            <img className='img_result' src={result.imageSrc}></img></td>
          <td>{result.answers[result.correctAnswer - 1]}</td>
          <td>{result.answers[result.userAnswer - 1]}</td>
        </tr>)
    }
    else {
      return (
        <tr key={result._id.$oid} className='not_selected'>
          <td><div>{result.question}</div>
            <img className='img_result' src={result.imageSrc}></img></td>
          <td>{result.answers[result.correctAnswer - 1]}</td>
          <td>לא נבחרה תשובה</td>
        </tr>)
    }
  });

  return (
    <div className="TestResult">
      <Container>
        <Row>
          <Col sm={1}></Col>
          <Col sm={10} >
            <div className='score'>ענית נכון על {score} מתוך 30 שאלות. בהצלחה בהמשך!</div>
            <Table bordered hover className='table'>
              <thead>
                <tr>
                  <th>השאלה</th>
                  <th>התשובה הנכונה</th>
                  <th>התשובה שהזנת</th>
                </tr>
              </thead>
              <tbody>
                {tableResult}
              </tbody>
            </Table>
          </Col>
          <Col sm={1}></Col>
        </Row>
      </Container>
    </div>
  )
}

export default TestResult;